export default __webpack_public_path__ + "static/media/sagiper-screensaver.0303dd0a.mp4";